/**
 * Единственное место, где живёт имя продукта.
 *
 * README обещает: «переименование стоит ровно один коммит: имя живёт в
 * `packages/shared/src/brand.ts` и в именах Docker-образов». Поэтому здесь
 * нет ни одного дублирующегося строкового литерала — всё остальное считается
 * от `BRAND.name` / `BRAND.slug`.
 *
 * Правило для остального кода: нигде больше не писать «Apiary» руками —
 * ни в UI, ни в логах, ни в заголовках писем.
 */

/** Отображаемое имя продукта. Меняется здесь — меняется везде. */
const NAME = 'Apiary'

/** Машинное имя: docker-образы, БД, npm-scope, префиксы метрик. */
const SLUG = 'apiary'

export const BRAND = {
  /** «Apiary» — заголовки, логотип, письма. */
  name: NAME,
  /** «apiary» — образы, имена сервисов, префиксы. */
  slug: SLUG,
  /** Короткое описание для <title>, og:description, README. */
  tagline: 'панель управления флотом Minecraft-ботов',
  /** Scope воркспейс-пакетов: `@apiary/shared`, `@apiary/mc-compat`. */
  npmScope: `@${SLUG}`,
  /** Префикс имён docker-образов (ADR-14). */
  imagePrefix: `ghcr.io/vladbogun1/${SLUG}`,
  /** Префикс метрик Prometheus: `apiary_bots_playing`. */
  metricPrefix: `${SLUG}_`,
  /** База для RFC 9457 `type`-URI ошибок (docs/06 §1). */
  errorTypeBaseUrl: `https://${SLUG}.local/errors`,
  /** Префикс API-ключей: `ak_<id>.<secret>` (ADR-08) — намеренно нейтральный. */
  apiKeyPrefix: 'ak_'
} as const

export type Brand = typeof BRAND

/** Удобный алиас для UI: `<h1>{PRODUCT_NAME}</h1>`. */
export const PRODUCT_NAME = BRAND.name

/** `Apiary — панель управления флотом Minecraft-ботов` */
export const PRODUCT_TITLE = `${BRAND.name} — ${BRAND.tagline}`
